import React, { useState, useCallback } from "react";
import { useTranslation } from "react-i18next";

// Custom Components
import VirtualScrollTable from "../../components/ReactTable/VirtualScrollTable";
import { getSortString } from "../../utils/tableUtils";
import { useLocationEmployees } from "../../hooks/locations";
import { useVirtualScrolling } from "../../components/ReactTable/useVirtualScrolling";

const pageSize = 25;

const LocationEmployeesTable = ({ locationId }) => {
  const { t } = useTranslation();
  const [tableState, setTableState] = useState({ page: 1, sortBy: "" });
  const { sortBy, page } = tableState;
  const { fetchEmployees } = useLocationEmployees({
    location: locationId
  });

  const fetchData = useCallback(() => {
    return fetchEmployees({
      page,
      size: pageSize,
      sortBy
    });
  }, [tableState]);

  const {
    results: employees,
    hasNextPage,
    loadingFirstPage
  } = useVirtualScrolling({
    fetchData,
    page
  });

  const usersColumns = [
    {
      Header: t("administration.name"),
      accessor: row => `${row.firstName} ${row.lastName}`,
      id: "lastName",
      width: 150
    },
    {
      Header: t("administration.position"),
      accessor: "position.name",
      id: "position_name",
      width: 150
    },
    {
      Header: t("administration.compliance"),
      accessor: row => `${row.compliance}%`,
      id: "compliance",
      disableSortBy: true,
      width: 75
    }
  ];

  const handleTableStateChange = useCallback(
    newState => {
      const newSort = getSortString(newState.sortBy[0]);
      const newPage = newState.pageIndex;
      if (newSort !== sortBy || newPage !== page) {
        setTableState({ sortBy: newSort, page: newState.pageIndex });
      }
    },
    [sortBy, page]
  );

  return (
    <VirtualScrollTable
      columns={usersColumns}
      data={employees || []}
      loading={loadingFirstPage}
      totalCount={hasNextPage ? employees.length + 1 : employees.length}
      pageSize={pageSize}
      onStateChange={handleTableStateChange}
    />
  );
};

export default LocationEmployeesTable;
